import { render, staticRenderFns } from "./CommentsBlockComponent.vue?vue&type=template&id=42b48a2f&scoped=true&"
import script from "./CommentsBlockComponent.vue?vue&type=script&lang=js&"
export * from "./CommentsBlockComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBlockComponent.vue?vue&type=style&index=0&id=42b48a2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b48a2f",
  null
  
)

export default component.exports